import { configureAppStore } from "./store";

export const configureStore = configureAppStore();
